import "./anexoI3.scss";
import Titulo from "../../components/atoms/titles/Titulo";
//import { Formik, Form } from "formik";
import { useEffect, useState } from "react";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
// import { getIdiomasYotros } from "../../components/services/ConcursosService";
import { useLocation, useParams } from "react-router-dom";
//import { SpinnerCircleMini } from "../../components/atoms/spinner/Spinner";
import { Iconos } from "../../utils/Iconos";
import Select from "react-select";
import { getListadoAreaFormativaI3, getSelectIdiomasYOtrosMeritosI3, getSelectTiposPublicacionI3, grabarAnexoI3, obtenerAnexoI3 } from "../../components/services/ConcursosService";

const AnexoI3Limpio = () => {
    const location = useLocation()
    
    
    const params = useParams();

    const [show, setShow] = useState({
        mensaje: false,
    });
    const handleClose = (e) => {
        setShow(false);
    };

    const [areasFormativasSelect, setAreasFormativasSelect] = useState([])
    const [ setAreasFormativas] = useState([]) // arreglar una vez se adapten bien los servicios

    // const [titulacionesSelect, setTitulacionesSelect] = useState([])

    const [idiomasYotrosMeritosSelect, setIdiomasYotrosMeritosSelect] = useState([])

    const [tipoPublicacionSelect, setTipoPublicacionSelect] = useState([])

    const [datosAnexo, setDatosAnexo] = useState({
        //formacion recibida
        formRecibida: [
            {
                wsolixsolicitud: params?.idSol,
                oefcorgexpfor: null, // codigo organismo (se insertan nulos)
                dorgexpfor: "", //organismo
                cfoccurfor: null, // codigo curso (se insertan nulos)
                dcurfor: "", //curso
                lforrec: "S", //constante para metodo BD (boolean true para indicar que es formacion recibida)
                laprovech: "N", // certif aprovechamiento (boolean)
                nhoras: 0,
                ncreditos: 0,
                ndias: 0
                //Areas formativas pendientes
            }
        ],

        //formacion impartida
        formImpartida: [
            {
                wsolixsolicitud: params?.idSol,
                oefcorgexpfor: null, // codigo organismo (se insertan nulos inicialmente)
                dorgexpfor: "", //organismo
                cfoccurfor: null, // codigo curso (se insertan nulos inicialmente)
                dcurfor: "", //curso
                lforrec: "N", //constante para metodo BD (boolean false)
                // laprovech: "N", // certif aprovechamiento (boolean)
                nhoras: 0,
                // ncreditos: 0,
                // ndias: 0
                //Areas formativas pendientes
            }
        ],

        // // titulacion academicas
        // titAca: [
        //     {
        //         idorganismo: null, //codigo organismo (nulo)
        //         dorganismo: "", //organismo
        //         idtitulacion: "", //valores cargables desde el select de titulacion (hace falta que haya datos)
        //         dtitulacion: "", //valores cargables desde el select de titulacion (hace falta que haya datos)
        //         wsolixsolicitud: params?.idsol
        //     }
        // ],

        //idiomas y otros meritos
        idiomas: [
            {
                cIdiomaMerito: "",
                dIdiomaMerito: "",
            }
        ],

        //publicaciones
        publicaciones: [
            {
                cpubtipo: null, // codigo tipo publicacion (nulo inicial)
                npubtipo: "", //tipo publicacion
                npubtitulo: "", //titulo;
                npubisbn: "" //ISBN
            }
        ]
    });

    //Formacion recibida
    //Handle para cargar los datos
    const handleValueFR = (index, value, name) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newFormRecibida = [...prevDatosAnexo.formRecibida];
            newFormRecibida[index][name] = value;
            newFormRecibida[index].wsolixsolicitud = params?.idsol;
            return { ...prevDatosAnexo, formRecibida: newFormRecibida };
        });
    };

    //Metodos para crear y eliminar secciones en la vista
    const anadirFormacionRecibida = () => {
        setDatosAnexo((prevDatosAnexo) => {
            const newFormRecibida = [...prevDatosAnexo.formRecibida];
            const nuevoId = newFormRecibida.length + 1;
            newFormRecibida.push({
                id: nuevoId,
                wsolixsolicitud: params?.idSol,
                oefcorgexpfor: null,
                dorgexpfor: "",
                cfoccurfor: null,
                dcurfor: "",
                lforrec: "N",
                laprovech: "N",
                nhoras: 0,
                ncreditos: 0,
                ndias: 0
            });
            return { ...prevDatosAnexo, formRecibida: newFormRecibida };
        });
    };

    const eliminarFormacion = (id) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newFormRecibida = prevDatosAnexo.formRecibida.filter((formacion) => formacion.id !== id);
            return { ...prevDatosAnexo, formRecibida: newFormRecibida };
        });
    };


    //Formacion impartida
    //Handle para cargar los datos
    const handleValueFI = (index, value, name) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newFormImpartida = [...prevDatosAnexo.formImpartida];
            newFormImpartida[index][name] = value;
            newFormImpartida[index].wsolixsolicitud = params?.idsol;
            return { ...prevDatosAnexo, formImpartida: newFormImpartida };
        });
    };

    //Metodos para crear y eliminar secciones en la vista
    const anadirFormacionImpartida = () => {
        setDatosAnexo((prevDatosAnexo) => {
            const newFormImpartida = [...prevDatosAnexo.formImpartida];
            const nuevoId = newFormImpartida.length + 1;
            newFormImpartida.push({
                id: nuevoId,
                wsolixsolicitud: params?.idSol,
                oefcorgexpfor: null, // codigo organismo (se insertan nulos inicialmente)
                dorgexpfor: "", //organismo
                cfoccurfor: null, // codigo curso (se insertan nulos inicialmente)
                dcurfor: "", //curso
                lforrec: "N", //constante para metodo BD (boolean false)
                // laprovech: "N", // certif aprovechamiento (boolean)
                nhoras: 0,
                // ncreditos: 0,
                // ndias: 0
                //Areas formativas pendientes
            });
            return { ...prevDatosAnexo, formImpartida: newFormImpartida };
        });
    };

    const eliminarFormacionImpartida = (id) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newFormImpartida = prevDatosAnexo.formImpartida.filter((formacion) => formacion.id !== id);
            return { ...prevDatosAnexo, formImpartida: newFormImpartida };
        });
    };

    //   Titulaciones Academicas
    // const handleValueTA = (index, value, name) => {
    //     setDatosAnexo((prevDatosAnexo) => {
    //         const newTitAca = [...prevDatosAnexo.titAca];
    //         newTitAca[index][name] = value;
    //         newTitAca[index].wsolixsolicitud = params?.idsol;
    //         return { ...prevDatosAnexo, titAca: newTitAca };
    //     });
    // };

    // const anadirTitulaciones = () => {
    //     setDatosAnexo((prevDatosAnexo) => {
    //         const newTitAca = [...prevDatosAnexo.titAca];
    //         const nuevoId = newTitAca.length + 1;
    //         newTitAca.push({
    //             id: nuevoId,
    //             oefcorgexpfor: null,
    //             dorgexpfor: "",
    //             titctitulacion: "",
    //             dtitulacion: "",
    //             wsolixsolicitud: params?.idsol,
    //         });
    //         return { ...prevDatosAnexo, titAca: newTitAca };
    //     });
    // };

    // const eliminarTitulaciones = (id) => {
    //     setDatosAnexo((prevDatosAnexo) => {
    //         const newTitAca = prevDatosAnexo.titAca.filter((titulacion) => titulacion.id !== id);
    //         return { ...prevDatosAnexo, titAca: newTitAca };
    //     });
    // };

    //Idiomas y otros meritos
    const handleValueIM = (index, value, name) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newIdiomasMerito = [...prevDatosAnexo.idiomas];
            newIdiomasMerito[index][name] = value;
            return { ...prevDatosAnexo, idiomas: newIdiomasMerito };
        });
    };

    const anadirIdiomasMerito = () => {
        setDatosAnexo((prevDatosAnexo) => {
            const newIdiomasMerito = [...prevDatosAnexo.idiomas];
            const nuevoId = newIdiomasMerito.length + 1;
            newIdiomasMerito.push({
                id: nuevoId,
                cidiomamerito: "",
                didiomamerito: "",
            });
            return { ...prevDatosAnexo, idiomas: newIdiomasMerito };
        });
    };

    const eliminarIdiomasMerito = (id) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newIdiomasMerito = prevDatosAnexo.idiomas.filter((idioma) => idioma.id !== id);
            return { ...prevDatosAnexo, idiomas: newIdiomasMerito };
        });
    };

    //Publicaciones
    const handleValueP = (index, value, name) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newPublicaciones = [...prevDatosAnexo.publicaciones];
            newPublicaciones[index][name] = value;
            return { ...prevDatosAnexo, publicaciones: newPublicaciones };
        });
    };

    const anadirPublicaciones = () => {
        setDatosAnexo((prevDatosAnexo) => {
            const newPublicaciones = [...prevDatosAnexo.publicaciones];
            const nuevoId = newPublicaciones.length + 1;
            newPublicaciones.push({
                id: nuevoId,
                cpubtipo: null,
                npubtipo: "",
                npubtitulo: "",
                npubisbn: "",
            });
            return { ...prevDatosAnexo, publicaciones: newPublicaciones };
        });
    };

    const eliminarPublicaciones = (id) => {
        setDatosAnexo((prevDatosAnexo) => {
            const newPublicaciones = prevDatosAnexo.publicaciones.filter((publicacion) => publicacion.id !== id);
            return { ...prevDatosAnexo, publicaciones: newPublicaciones };
        });
    };

    useEffect(() => {
        getListadoAreaFormativaI3(params?.idsol).then((data) => {
            
            const areaF = data.map((item) => {
                return {
                    value: item?.careaf,
                    label: item?.dareaF,
                };
            });
            setAreasFormativasSelect(areaF)
            // setAreasFormativas(data)
        });

        // getSelectTitulacionesI3(params?.idsol).then((data) => {
        //     
        //     setTitulacionesSelect(data.map((item) => {
        //         return {
        //             value: item?.cmerito,
        //             label: item?.dmerito,
        //         };
        //     }))
        // });

        getSelectIdiomasYOtrosMeritosI3(params?.idsol).then((data) => {
            
            setIdiomasYotrosMeritosSelect(data.map((item) => {
                return {
                    value: item?.cIdiomaMerito,
                    label: item?.dIdiomaMerito,
                };
            }))
        });

        getSelectTiposPublicacionI3(params?.idsol).then((data) => {
            
            setTipoPublicacionSelect(data.map((item) => {
                return {
                    value: item?.cpubtipo,
                    label: item?.npubtipo,
                };
            }))
        });
    }, [params, setAreasFormativas])

    useEffect(() => {
        const completarConValoresPorDefecto = (data, prevDatosAnexo) => {
            return Object.fromEntries(
                Object.entries(data).map(([key, value]) => [
                    key,
                    Array.isArray(value) && value.length === 0
                        ? prevDatosAnexo[key] || value
                        : value,
                ])
            );
        };

        obtenerAnexoI3(params?.idsol).then((data) => {
            
            setDatosAnexo((prevDatosAnexo) => completarConValoresPorDefecto(data, prevDatosAnexo));
        });
    }, [params]);


    return (
        <>
            <Header></Header>
            <div
                className="container d-flex flex-column min-vh-100 card mt-5"
                id="inicio"
                role="main" data-landmark-index="4"
            >
                <div className="my-auto">
                    <div className="container-login">
                        <div className="tituloSolicitud">
                            {/*<Titulo titulo={"Anexo I.3"} tipo={"tituloPagina"} />*/}
                            <h2 className="tituloPagina">Anexo I.3</h2>
                            <div className="d-flex align-items-center flex-column">
                                {/* <Titulo
                                    titulo={"ALEGACIÓN DE MÉRITOS"}
                                    tipo={"tituloPagina subTituloPagina"}
                                /> */}
                                <h3 className="tituloPagina subtituloPagina">ALEGACIÓN DE MÉRITOS</h3>
                            </div>

                            <div className="d-flex flex-column m-2">
                                <div className="infoAnexoII4">
                                    <p>
                                        Convocatoria para la provisión de puestos de trabajo
                                        vacantes singularizados de personal funcionario de la
                                        Administración de la Comunidad Autónoma de Extremadura, (DOE
                                        nº 97 de fecha 22/05/2015).
                                    </p>
                                </div>
                                <div className="nSolicitud">
                                    <p>
                                        Nº de solicitud:{" "}
                                        <span className="fw-bold">{location.state?.numSol}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="formulario">
                                {/* Actividad Formativa */}
                                <div className="actividadFormativaII4">
                                    {/* <Titulo
                                        clases={"subSubTituloSolicitud px-3 py-2 fw-bold"}
                                        tipo={"tituloBorrador noBg"}
                                        titulo={"Actividad Formativa"}
                                    ></Titulo> */}
                                    <div className="subSubTituloSolicitud px-3 py-2 fw-bold">
                                        <h4 className="tituloBorrador noBg">Actividad Formativa</h4>
                                    </div>
                                    {/* <Titulo
                                        clases={"subSubTituloSolicitud p-2 fw-bold"}
                                        tipo={"tituloCard noBg"}
                                        titulo={
                                            "Formación Recibida Fuera De La Escuela De Administración Pública"
                                        }
                                    ></Titulo> */}
                                    <div className="subSubTituloSolicitud ps-4 py-2 fw-bold">
                                        <h4 className="tituloBorrador noBg">Formación Recibida Fuera De La Escuela De Administración Pública</h4>
                                    </div>
                                    <div className="formacionRecibidaII4">
                                        <div className="">
                                            {datosAnexo.formRecibida.map((formacionR, i) => (
                                                <div
                                                    className="formacionRecibidaII4Grid row mx-2"
                                                    key={`${formacionR.id}_${i}`}
                                                >
                                                    <div className="col-lg-2 col-md-3 orgFR align-self-center">
                                                        {i === 0 ? <label htmlFor="dorgexpfor" className="tituloForm">Organismo:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="dorgexpfor"
                                                            id="dorgexpfor"
                                                            placeholder="Organismo"
                                                            className="form-control mt-2"
                                                            defaultValue={formacionR.dorgexpfor}
                                                            onChange={(e) => handleValueFR(i, e.target.value, "dorgexpfor")}
                                                        />
                                                    </div>
                                                    <div className="col-lg-2 col-md-3 cursoFR align-self-center">
                                                        {i === 0 ? <label htmlFor="dcurfor" className="tituloForm">Curso:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="dcurfor"
                                                            placeholder="Curso"
                                                            className="form-control mt-2"
                                                            id="dcurfor"
                                                            defaultValue={formacionR.dcurfor}
                                                            onChange={(e) => handleValueFR(i, e.target.value, "dcurfor")}
                                                        />
                                                    </div>
                                                    <div className={`col-lg-2 col-md-3 areaFR ${i === 0 ? 'mb-sm-0 mb-lg-0' : null}`}>
                                                        {i === 0 ? <label htmlFor="areaFormFR" className="tituloForm">Área/s Formativa/s:</label> : <span></span>}
                                                        <Select
                                                            name="areaFormFR"
                                                            id="areaFormFR"
                                                            isMulti
                                                            options={areasFormativasSelect}
                                                            className="mt-2"
                                                            isClearable
                                                            onChange={(e) => {
                                                                //options elegidos en formato label - value
                                                                
                                                                //listado de areas filtrado en base a los escogidos anteriormente (para enviar FR) 
                                                                //(seguramente sea lo suyo crear un estado independiente a los que hay para enviar ese al back)
                                            
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-lg-1 col-md-1 certFR me-3 align-self-center">
                                                        {i === 0 ? (<label htmlFor="laprovech" className="tituloForm">Certif. Aprovech.:</label>) : null}
                                                        <input
                                                            type="checkbox"
                                                            id="laprovech"
                                                            name="laprovech"
                                                            className={`form-check-input ${i !== 0 ? 'mt-3' : null}`}
                                                            defaultChecked={formacionR.laprovech === "S" ? true : false}
                                                            onChange={(e) => {
                                                                e.target.checked ?
                                                                    handleValueFR(i, "S", "laprovech") :
                                                                    handleValueFR(i, "N", "laprovech")
                                                            }}

                                                            title="Certtificado de aprovechamiento"
                                                            aria-label="Certificado de aprovechamiento"
                                                        />
                                                    </div>
                                                    <div className="col-lg-1 col-md-2 credFR align-self-center">
                                                        {i === 0 ? <label htmlFor="ncreditos" className="tituloForm">Créd:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="ncreditos"
                                                            id="ncreditos"
                                                            placeholder="Créd"
                                                            className="form-control mt-2"
                                                            defaultValue={formacionR.ncreditos}
                                                            onChange={(e) => handleValueFR(i, e.target.value, "ncreditos")}
                                                        />
                                                    </div>
                                                    <div className="col-lg-1 col-md-2 diasFR align-self-center">
                                                        {i === 0 ? <label htmlFor="ndias" className="tituloForm">Días:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="ndias"
                                                            placeholder="Días"
                                                            className="form-control mt-2"
                                                            defaultValue={formacionR.ndias}
                                                            onChange={(e) => handleValueFR(i, e.target.value, "ndias")}
                                                        />
                                                    </div>
                                                    <div className="col-lg-1 col-md-2 horasFR align-self-center">
                                                        {i === 0 ? <label htmlFor="nhoras" className="tituloForm">Horas:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="nhoras"
                                                            id="nhoras"
                                                            placeholder="Horas"
                                                            className="form-control mt-2"
                                                            defaultValue={formacionR.curso}
                                                            onChange={(e) => handleValueFR(i, e.target.value, "nhoras")}
                                                        />
                                                    </div>
                                                    <div className="col-lg-1 col-md-1 col-sm-2 align-self-center d-flex justify-content-center">
                                                        <i
                                                            className={`fa-solid fa-remove fs-2 text-third-1 cursorPointer ${i === 0 ? 'pt-4' : null}`}
                                                            name="cerrarFR"
                                                            title="Eliminar formación recibida"
                                                            aria-label="Eliminar formación recibida"
                                                            tabIndex={0}
                                                            onClick={() => {
                                                                eliminarFormacion(formacionR.id)
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    eliminarFormacion(formacionR.id)
                                                                }
                                                            }}>
                                                        </i>
                                                    </div>
                                                </div>
                                            ))}
                                            <i className="fa-solid  mt-3"
                                                onClick={anadirFormacionRecibida}
                                                title="Añadir formación recibida"
                                                aria-label="Añadir formación recibida"
                                                tabIndex={0}

                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        anadirFormacionRecibida()
                                                    }
                                                }}
                                            >
                                                <span className=" m-3 cursorPointer textAnadir">

                                                    {Iconos.iconoMas} Añadir

                                                </span>
                                            </i>
                                        </div>
                                    </div>
                                    <div className="formacionImpartidaII4">
                                        {/* <Titulo
                                            clases={"subSubTituloSolicitud p-2 fw-bold"}
                                            tipo={"tituloCard noBg"}
                                            titulo={
                                                "Formación Impartida Fuera De La Escuela De Administración Pública"
                                            }
                                        ></Titulo> */}
                                        <div className="subSubTituloSolicitud ps-4 py-2 fw-bold">
                                            <h4 className="tituloBorrador noBg">Formación Impartida Fuera De La Escuela De Administración Pública</h4>
                                        </div>
                                        <div className="">
                                            {datosAnexo.formImpartida.map((formacionI, i) => (
                                                <div
                                                    className="formacionImpartidaII4Grid mx-2 row"
                                                    key={`${formacionI.id}_${i}`}
                                                >
                                                    <div className="orgFI m-2 col-lg-3">
                                                        {i === 0 ? <label htmlFor="orgFI" className="tituloForm">Organismo:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="orgFI"
                                                            placeholder="Organismo"
                                                            className="form-control mt-2"
                                                            defaultValue={formacionI.dorgexpfor}
                                                            onChange={(e) => handleValueFI(i, e.target.value, "dorgexpfor")}
                                                        />
                                                    </div>
                                                    <div className="cursoFI m-2 col-lg-3">
                                                        {i === 0 ? <label htmlFor="cursoFI" className="tituloForm">Curso:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="cursoFI"
                                                            placeholder="Curso"
                                                            className="form-control mt-2"
                                                            defaultValue={formacionI.dcurfor}
                                                            onChange={(e) => handleValueFI(i, e.target.value, "dcurfor")}
                                                        />
                                                    </div>
                                                    <div className="areaFI m-2 col-lg-3">
                                                        {i === 0 ? <label htmlFor="areaFormFI" className="tituloForm">Área/s Formativa/s:</label> : <span></span>}
                                                        <Select
                                                            name="areaFormFI"
                                                            id="areaFormFI"
                                                            isMulti
                                                            options={areasFormativasSelect}
                                                            className="mt-2"
                                                            isClearable
                                                            onChange={(e) => {
                                                                //options elegidos en formato label - value
                                                                
                                                                //listado de areas filtrado en base a los escogidos anteriormente (para enviar FI) 
                                                                //(seguramente sea lo suyo crear un estado independiente a los que hay para enviar ese al back)
                                                                
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="horasFI m-2 col-lg-1">
                                                        {i === 0 ? <label htmlFor="horasFI" className="tituloForm">Horas:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="horasFI"
                                                            placeholder="Horas"
                                                            className="form-control mt-2"
                                                            defaultValue={formacionI.nhoras}
                                                            onChange={(e) => handleValueFI(i, e.target.value, "nhoras")}
                                                        />
                                                    </div>

                                                    <div className="cerrarFI d-flex justify-content-center col-1">
                                                        {i === 0 ?
                                                            <i
                                                                className="fa-solid fa-remove fs-2 m-3 text-third-1 pt-4 cursorPointer "
                                                                name="cerrarFI"
                                                                onClick={() => {
                                                                    eliminarFormacionImpartida(formacionI.id);
                                                                }}
                                                                title="Eliminar formación impartida"
                                                                aria-label="Eliminar formación impartida"
                                                                tabIndex={0}
                                                                role="button"
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                        eliminarFormacionImpartida(formacionI.id);
                                                                    }
                                                                }}
                                                            ></i> : <i
                                                                className="fa-solid fa-remove fs-2 text-third-1 pt-4 cursorPointer "
                                                                name="cerrarFI"
                                                                onClick={() => {
                                                                    eliminarFormacionImpartida(formacionI.id);
                                                                }}
                                                                title="Eliminar formación impartida"
                                                                aria-label="Eliminar formación impartida"
                                                                tabIndex={0}
                                                                role="button"
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                        eliminarFormacionImpartida(formacionI.id);
                                                                    }
                                                                }}
                                                            ></i>}
                                                    </div>
                                                </div>
                                            ))}
                                            <i className="fa-solid mt-3"
                                                onClick={anadirFormacionImpartida}
                                                title="Añadir formación impartida"
                                                aria-label="Añadir formación impartida"
                                                tabIndex={0}
                                                role="button"
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        anadirFormacionImpartida()
                                                    }
                                                }}
                                            >
                                                <span className=" m-3 cursorPointer textAnadir">

                                                    {Iconos.iconoMas} Añadir

                                                </span>
                                            </i>
                                        </div>

                                    </div>
                                </div>

                                {/* Titulaciones Academicas
                                <div className="titulacionesAcademicasII4">
                                    <Titulo
                                        clases={"subSubTituloSolicitud p-2 fw-bold"}
                                        tipo={"tituloCard noBg"}
                                        titulo={"Titulaciones Académicas"}
                                    ></Titulo>
                                    <div className="d-flex flex-column">
                                        {datosAnexo.titAca.map((titulacion, i) => (
                                            <div className="d-flex m-2" key={`${titulacion.id}_${i}`}>
                                                <div className="flex-column m-2 w-100">
                                                    {i === 0 ? <label htmlFor="orgTit" className="tituloForm">Organismo:</label> : <span></span>}
                                                    <input
                                                        type="text"
                                                        name="orgTit"
                                                        placeholder="Organismo"
                                                        className="form-control mt-2"
                                                        id={titulacion.dorganismo}
                                                        defaultValue={titulacion.norganismo}
                                                        onChange={(e) => handleValueTA(i, e.target.value, "norganismo")}
                                                    />
                                                </div>
                                                <div className="flex-column m-2 w-100">
                                                    {i === 0 ? <label htmlFor="titulacionesSelect" className="tituloForm">Título:</label> : <span></span>}
                                                    <Select
                                                        name="titulacionesSelect"
                                                        id="titulacionesSelect"
                                                        // isMulti
                                                        options={titulacionesSelect}
                                                        className="mt-2"
                                                        // isClearable
                                                        onChange={(e) => {
                                                            handleValueTA(i, e.value, 'idtitulacion');
                                                            handleValueTA(i, e.label, 'dtitulacion');
                                                        }
                                                        }
                                                    />
                                                </div>
                                                {i === 0 ?
                                                    <i
                                                        className="fa-solid fa-remove fs-2 m-3 text-third-1 pt-4 cursorPointer"
                                                        title="Eliminar mérito"
                                                        onClick={() => {
                                                            eliminarTitulaciones(titulacion.id)
                                                        }}
                                                    ></i> :
                                                    <i
                                                        className="fa-solid fa-remove fs-2 m-3 text-third-1 pt-4 cursorPointer"
                                                        title="Eliminar mérito"
                                                        onClick={() => {
                                                            eliminarTitulaciones(titulacion.id)
                                                        }}
                                                    ></i>}
                                            </div>
                                        ))}
                                        <i className="fa-solid "
                                            title="Añadir mérito"
                                            onClick={anadirTitulaciones}
                                        >
                                            <span className=" m-3 cursorPointer textAnadir">

                                                {Iconos.iconoMas} Añadir

                                            </span>
                                        </i>
                                    </div>
                                </div> */}

                                {/* Otros Meritos */}
                                <div className="otrosMeritosII4">
                                    {/* <Titulo
                                        clases={"subSubTituloSolicitud px-3 py-2 fw-bold"}
                                        tipo={"tituloBorrador noBg"}
                                        titulo={"Otros Méritos"}
                                    ></Titulo> */}
                                    <div className="subSubTituloSolicitud px-3 py-2 fw-bold">
                                        <h4 className="tituloBorrador noBg">Otros Méritos</h4>
                                    </div>
                                    <div className="idiomasII4">
                                        {/* <Titulo
                                            clases={"subSubTituloSolicitud p-2 fw-bold"}
                                            tipo={"tituloCard noBg"}
                                            titulo={"Idiomas Y Otros Méritos"}
                                        ></Titulo> */}
                                        <div className="subSubTituloSolicitud ps-4 py-2 fw-bold">
                                            <h4 className="tituloBorrador noBg">Idiomas Y Otros Méritos</h4>
                                        </div>
                                        <div className="d-flex flex-column">
                                            {datosAnexo.idiomas.map((idiomamerito, i) => (
                                                <div className="d-flex" key={`${idiomamerito.id}_${i}`}>
                                                    <div className="flex-column w-100 m-2">
                                                        {i === 0 ? <label htmlFor="idiomaMerito" className="tituloForm">Mérito:</label> : <span></span>}
                                                        <Select
                                                            name="idiomaMerito"
                                                            id="idiomaMerito"
                                                            // isMulti
                                                            options={idiomasYotrosMeritosSelect}
                                                            className="mt-2 mx-2"
                                                            // isClearable
                                                            onChange={(e) => {
                                                                handleValueIM(i, e.value, 'cIdiomaMerito');
                                                                handleValueIM(i, e.label, 'dIdiomaMerito');
                                                            }
                                                            } />
                                                    </div>
                                                    <i
                                                        className="fa-solid fa-remove fs-2 m-3 text-third-1 pt-4 cursorPointer"
                                                        onClick={() => {
                                                            eliminarIdiomasMerito(idiomamerito.id)
                                                        }}
                                                        role="button"
                                                        title="Eliminar Idiomas y otros méritos"
                                                        aria-label="Eliminar Idiomas y otros méritos"
                                                        tabIndex={0}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === " ") {
                                                                eliminarIdiomasMerito(idiomamerito.id)
                                                            }
                                                        }}
                                                    ></i>
                                                </div>
                                            ))}
                                            <i className="fa-solid "
                                                onClick={anadirIdiomasMerito}
                                                title="Añadir Idiomas y otros méritos"
                                                aria-label="Añadir Idiomas y otros méritos"
                                                tabIndex={0}
                                                role="button"
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        anadirIdiomasMerito()
                                                    }
                                                }}
                                            >
                                                <span className=" m-3 cursorPointer textAnadir">

                                                    {Iconos.iconoMas} Añadir

                                                </span>
                                            </i>
                                        </div>
                                    </div>
                                    <div className="publicacionesII4">
                                        <Titulo
                                            clases={"subSubTituloSolicitud p-2 fw-bold"}
                                            tipo={"tituloCard noBg"}
                                            titulo={"Publicaciones"}
                                        ></Titulo>
                                        <div className="d-flex flex-column">
                                            {datosAnexo.publicaciones.map((publicacion, i) => (
                                                <div className="d-flex m-2" key={i}>
                                                    <div className="flex-column w-100 m-2">
                                                        {i === 0 ? <label htmlFor="tipoPublicacionSelect" className="tituloForm">Tipo:</label> : <span></span>}

                                                        <Select
                                                            name="idiomaMerito"
                                                            id="idiomaMerito"
                                                            // isMulti
                                                            options={tipoPublicacionSelect}
                                                            className="mt-2"
                                                            // isClearable
                                                            onChange={(e) => {
                                                                handleValueP(i, e.value, 'cpubtipo');
                                                                handleValueP(i, e.label, 'npubtipo');
                                                            }
                                                            } />
                                                    </div>
                                                    <div className="flex-column w-100 m-2">
                                                        {i === 0 ? <label htmlFor="titulacionesSelect" className="tituloForm">Título:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="titulo"
                                                            placeholder="Título"
                                                            className="form-control mt-2"
                                                            defaultValue={publicacion.npubtitulo}
                                                            onChange={(e) => { handleValueP(i, e.target.value, "npubtitulo") }}
                                                        />
                                                    </div>
                                                    <div className="flex-column w-100 m-2">
                                                        {i === 0 ? <label htmlFor="titulacionesSelect" className="tituloForm">ISBN:</label> : <span></span>}
                                                        <input
                                                            type="text"
                                                            name="isbn"
                                                            placeholder="ISBN"
                                                            className="form-control mt-2"
                                                            defaultValue={publicacion.npubisbn}
                                                            onChange={(e) => { handleValueP(i, e.target.value, "npubisbn") }}
                                                        />
                                                    </div>
                                                    <i
                                                        className="fa-solid fa-remove fs-2 m-3 text-third-1 pt-4 cursorPointer"

                                                        onClick={() => {
                                                            eliminarPublicaciones(publicacion.id)
                                                        }}
                                                        title="Eliminar publicaciones"
                                                        aria-label="Eliminar publicaciones"
                                                        tabIndex={0}
                                                        role="button"
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " ") {
                                                                eliminarPublicaciones(publicacion.id)
                                                            }
                                                        }}
                                                    ></i>
                                                </div>
                                            ))}
                                            <i className="fa-solid "
                                                onClick={anadirPublicaciones}
                                                title="Añadir publicaciones"
                                                aria-label="Añadir publicaciones"
                                                tabIndex={0}
                                                role="button"
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        anadirPublicaciones()
                                                    }
                                                }}
                                            >
                                                <span className=" m-3 cursorPointer textAnadir">

                                                    {Iconos.iconoMas} Añadir

                                                </span>
                                            </i>
                                        </div>
                                    </div>
                                </div>

                                {/* Botones */}
                                <div className="d-flex justify-content-center gap-3 mt-5 row">
                                    {/* Botón Cancelar */}
                                    <div className="col-md-5 col-12 order-2 order-md-1">
                                        <button
                                            type="button"
                                            className="btnRed rounded botonVolverAnexoI1"
                                            onClick={() =>
                                                setShow({
                                                    mensaje: true,
                                                    content: "¿Deseas cancelar el formulario?",
                                                    tipo: "tituloModal",
                                                    aviso: true,
                                                    destinoAviso: `/concurso/${params?.idcon}`,
                                                })
                                            }
                                        >
                                            <i className="fa-solid fa-rotate-left"></i> Volver
                                        </button>
                                    </div>

                                    {/* Botón Guardar borrador */}
                                    <div className="col-md-5 col-12 order-1 order-md-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary botonGuardarAnexoI3"
                                            // disabled={cargaBoton}
                                            onClick={async () => {
                                                
                                                grabarAnexoI3(datosAnexo, params?.idcon, params?.idsol).then(() => { })

                                            }}
                                        >
                                            <i className="fa-solid fa-save"></i> Guardar
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
            {show.mensaje ? (
                <ModalMensajes
                    show={show.mensaje}
                    handleClose={handleClose}
                    texto={show.content}
                    tipo={show.tipo}
                    aviso={show.aviso}
                    destinoAviso={show.destinoAviso}
                    destinoCerrar={show?.destinoCerrar}
                ></ModalMensajes>
            ) : null}
        </>
    );
}

export default AnexoI3Limpio;